// extracted by mini-css-extract-plugin
export default {"addToCartControl":"h2-z","giftCard":"i2-z","btnContainer":"j2-z","cartButton":"k2-z","disabled":"l2-z"};